/**
 * Lucide icons bundled into app.js. Each is deep-imported from its own module
 * so the bundle carries only these (the full set is ~7MB, and dev builds do
 * not tree-shake). Add any icon you reference via <x-icon name="…">,
 * data-lucide, config/platform.php or App/Support/StatusStyle here, as
 * PascalCase: 'git-branch' → GitBranch. Browse names at https://lucide.dev/icons
 */
import Activity from 'lucide/dist/esm/icons/activity.mjs';
import AppWindow from 'lucide/dist/esm/icons/app-window.mjs';
import ArrowLeft from 'lucide/dist/esm/icons/arrow-left.mjs';
import ArrowUpFromLine from 'lucide/dist/esm/icons/arrow-up-from-line.mjs';
import ArrowRight from 'lucide/dist/esm/icons/arrow-right.mjs';
import AtSign from 'lucide/dist/esm/icons/at-sign.mjs';
import Bot from 'lucide/dist/esm/icons/bot.mjs';
import Check from 'lucide/dist/esm/icons/check.mjs';
import ChevronDown from 'lucide/dist/esm/icons/chevron-down.mjs';
import ChevronLeft from 'lucide/dist/esm/icons/chevron-left.mjs';
import ChevronRight from 'lucide/dist/esm/icons/chevron-right.mjs';
import ChevronUp from 'lucide/dist/esm/icons/chevron-up.mjs';
import CircleAlert from 'lucide/dist/esm/icons/circle-alert.mjs';
import CircleCheck from 'lucide/dist/esm/icons/circle-check.mjs';
import CircleDashed from 'lucide/dist/esm/icons/circle-dashed.mjs';
import CirclePause from 'lucide/dist/esm/icons/circle-pause.mjs';
import CircleQuestionMark from 'lucide/dist/esm/icons/circle-question-mark.mjs';
import CircleSlash from 'lucide/dist/esm/icons/circle-slash.mjs';
import CircleX from 'lucide/dist/esm/icons/circle-x.mjs';
import Code from 'lucide/dist/esm/icons/code.mjs';
import Clock from 'lucide/dist/esm/icons/clock.mjs';
import CornerDownLeft from 'lucide/dist/esm/icons/corner-down-left.mjs';
import Database from 'lucide/dist/esm/icons/database.mjs';
import Download from 'lucide/dist/esm/icons/download.mjs';
import Eye from 'lucide/dist/esm/icons/eye.mjs';
import EyeOff from 'lucide/dist/esm/icons/eye-off.mjs';
import FileArchive from 'lucide/dist/esm/icons/file-archive.mjs';
import Folder from 'lucide/dist/esm/icons/folder.mjs';
import GitBranch from 'lucide/dist/esm/icons/git-branch.mjs';
import GitCompare from 'lucide/dist/esm/icons/git-compare.mjs';
import GitMerge from 'lucide/dist/esm/icons/git-merge.mjs';
import GitMergeConflict from 'lucide/dist/esm/icons/git-merge-conflict.mjs';
import GitPullRequest from 'lucide/dist/esm/icons/git-pull-request.mjs';
import GitPullRequestArrow from 'lucide/dist/esm/icons/git-pull-request-arrow.mjs';
import House from 'lucide/dist/esm/icons/house.mjs';
import Info from 'lucide/dist/esm/icons/info.mjs';
import KeyRound from 'lucide/dist/esm/icons/key-round.mjs';
import List from 'lucide/dist/esm/icons/list.mjs';
import ListChecks from 'lucide/dist/esm/icons/list-checks.mjs';
import LoaderCircle from 'lucide/dist/esm/icons/loader-circle.mjs';
import LockKeyhole from 'lucide/dist/esm/icons/lock-keyhole.mjs';
import LogOut from 'lucide/dist/esm/icons/log-out.mjs';
import Mail from 'lucide/dist/esm/icons/mail.mjs';
import Menu from 'lucide/dist/esm/icons/menu.mjs';
import Moon from 'lucide/dist/esm/icons/moon.mjs';
import PanelLeftClose from 'lucide/dist/esm/icons/panel-left-close.mjs';
import PanelLeftOpen from 'lucide/dist/esm/icons/panel-left-open.mjs';
import Play from 'lucide/dist/esm/icons/play.mjs';
import Plus from 'lucide/dist/esm/icons/plus.mjs';
import RefreshCw from 'lucide/dist/esm/icons/refresh-cw.mjs';
import Rocket from 'lucide/dist/esm/icons/rocket.mjs';
import RotateCcw from 'lucide/dist/esm/icons/rotate-ccw.mjs';
import ScrollText from 'lucide/dist/esm/icons/scroll-text.mjs';
import Search from 'lucide/dist/esm/icons/search.mjs';
import Server from 'lucide/dist/esm/icons/server.mjs';
import ServerCog from 'lucide/dist/esm/icons/server-cog.mjs';
import Settings from 'lucide/dist/esm/icons/settings.mjs';
import ShieldCheck from 'lucide/dist/esm/icons/shield-check.mjs';
import Sparkles from 'lucide/dist/esm/icons/sparkles.mjs';
import Sun from 'lucide/dist/esm/icons/sun.mjs';
import SunMoon from 'lucide/dist/esm/icons/sun-moon.mjs';
import Terminal from 'lucide/dist/esm/icons/terminal.mjs';
import Trash from 'lucide/dist/esm/icons/trash.mjs';
import TriangleAlert from 'lucide/dist/esm/icons/triangle-alert.mjs';
import UserRound from 'lucide/dist/esm/icons/user-round.mjs';
import UserRoundSearch from 'lucide/dist/esm/icons/user-round-search.mjs';
import Users from 'lucide/dist/esm/icons/users.mjs';
import X from 'lucide/dist/esm/icons/x.mjs';

import Gauge from 'lucide/dist/esm/icons/gauge.mjs';
import File from 'lucide/dist/esm/icons/file.mjs';
import FolderOpen from 'lucide/dist/esm/icons/folder-open.mjs';
import Save from 'lucide/dist/esm/icons/save.mjs';
import Copy from 'lucide/dist/esm/icons/copy.mjs';
import ExternalLink from 'lucide/dist/esm/icons/external-link.mjs';
import MessageSquare from 'lucide/dist/esm/icons/message-square.mjs';
import MessagesSquare from 'lucide/dist/esm/icons/messages-square.mjs';
import Send from 'lucide/dist/esm/icons/send.mjs';
import ListFilter from 'lucide/dist/esm/icons/list-filter.mjs';

export default {
    Code,
    Copy,
    ExternalLink,
    MessageSquare,
    MessagesSquare,
    Send,
    ListFilter,
    File,
    FolderOpen,
    Save,
    Activity,
    Gauge,
    AppWindow,
    ArrowLeft,
    ArrowRight,
    ArrowUpFromLine,
    AtSign,
    Bot,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleAlert,
    CircleCheck,
    CircleDashed,
    CirclePause,
    CircleQuestionMark,
    CircleSlash,
    CircleX,
    Clock,
    CornerDownLeft,
    Database,
    Download,
    Eye,
    EyeOff,
    FileArchive,
    Folder,
    GitBranch,
    GitCompare,
    GitMerge,
    GitMergeConflict,
    GitPullRequest,
    GitPullRequestArrow,
    House,
    Info,
    KeyRound,
    List,
    ListChecks,
    LoaderCircle,
    LockKeyhole,
    LogOut,
    Mail,
    Menu,
    Moon,
    PanelLeftClose,
    PanelLeftOpen,
    Play,
    Plus,
    RefreshCw,
    Rocket,
    RotateCcw,
    ScrollText,
    Search,
    Server,
    ServerCog,
    Settings,
    ShieldCheck,
    Sparkles,
    Sun,
    SunMoon,
    Terminal,
    Trash,
    TriangleAlert,
    UserRound,
    UserRoundSearch,
    Users,
    X,
};
